import type { HTMLAttributes, ReactNode, Ref } from 'react';
import React from 'react';
import type { AccessibleClickableContainerProps } from '../accessibility';
import { AccessibleClickableContainer } from '../accessibility';

/**
 * Defines the list items, can contain any React.JSX.Elements (e.g. {@link AccessibleClickableContainer})
 */
export interface ListItemProps
  extends Partial<AccessibleClickableContainerProps> {
  children: ReactNode;
  className?: string;
}

export function ListItem({
  ref,
  ...props
}: Readonly<ListItemProps> &
  Pick<HTMLAttributes<HTMLElement>, 'style'> & {
    ref?: Ref<HTMLLIElement>;
  }): React.JSX.Element {
  const { onClick, className, children, disabled, ...reducedProps } = props;
  const classNames = ['ehs-list-item'];
  if (className) {
    classNames.push(className);
  }
  return onClick ? (
    <li
      {...reducedProps}
      ref={ref}
      className={classNames.join(' ').trim()}
      aria-label={undefined}
    >
      <AccessibleClickableContainer
        className="ehs-clickable"
        disabled={disabled}
        onClick={onClick}
        aria-label={props['aria-label']}
      >
        {children}
      </AccessibleClickableContainer>
    </li>
  ) : (
    <li {...props} ref={ref} className={classNames.join(' ').trim()}>
      {children}
    </li>
  );
}
